import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CHeader,
  CToggler,
  CSubheader,
  CBreadcrumbRouter,
} from '@coreui/react';

// routes config
import { routes, clientRoutes } from 'modules/app/config/routes';

import { toogleSidebar } from 'modules/app/app.actions';
import Dropdown from './dropdown.component';

const Header = () => {
  const dispatch = useDispatch();
  const isAdmin = useSelector((state) => state.auth.isAdmin);

  return (
    <CHeader withSubheader className="justify-content-between">
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none py-3"
        onClick={() => dispatch(toogleSidebar())}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none py-3"
        onClick={() => dispatch(toogleSidebar())}
      />
      <Dropdown />

      <CSubheader className="px-3 justify-content-between">
        <CBreadcrumbRouter
          className="border-0 c-subheader-nav m-0 px-0 px-md-3"
          routes={isAdmin ? routes : clientRoutes}
        />
      </CSubheader>

    </CHeader>
  );
};

export default Header;
